import React, { createRef, useEffect, useState } from 'react';
import axios, { AxiosResponse } from 'axios';
import CssBaseline from '@material-ui/core/CssBaseline';
import PrimarySearchAppBar from '../components/Appbar'
import Helmet from 'react-helmet';
import { Box, Button, MenuItem, Paper, Tab, Tabs, TextField, Typography } from '@material-ui/core';
import ReactHookFormSelect from '../components/ReactHookFormSelect';
import { Catagories } from '../util/HardCodedLists';
import ImageUploader from '../components/ImageUploader';
import { Control, Controller, useForm } from 'react-hook-form';
import ChipInput from '../components/chipInput';
import { useSnackbar } from 'notistack';
import RTE from '../components/RTE';
import SimpleConfirm from '../components/SimpleConfirm';
import EditAppBar from '../components/EditAppbar';
import { PostRenderer } from './PostRenderer';

type Post = {
    BannerImage: any;
    Content<T>(Content: any): [any, any]; PublicID: string; Title: string; Description: any; Category: any; Visibility: any;
};

const BlogEdit = (props: { post: Post; history: { pathname: string; state: { message: string; }; }[]; isLoggedIn: any; isLoading: any; visible: any; }) => {

    const [images, setimages] = useState([props.post.BannerImage]);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [tabValue, setTabValue] = useState(0);

    const { register, handleSubmit, control, errors, clearErrors, getValues } = useForm({ mode: 'onChange', shouldUnregister: false });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    function deleteList() {
        axios.delete(`/api/list/${props.post.PublicID}`, { withCredentials: true }).then(() => {
            props.history.push({
                pathname: '/',
                state: { message: 'Your list was yeeted into outer space' }
            })
        });
    }

    //Save post
    const onSubmit = async (postData) => {
        //Update posted date
        console.log(postData);

        //post to /posts/:id
        await axios.post(`/api/posts/${props.post.PublicID}`, postData, { withCredentials: true });
        // await axios.post(`/api/posts/new`, postData, { withCredentials: true });

        //navigate home
        props.history.push({
            pathname: '/posts/' + props.post.PublicID,
            state: { message: 'Your post was updated' }
        });
    }

    //listen for tab key to switch tab value
    useEffect(() => {
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Tab') {
                e.preventDefault();
                setTabValue((tabVal) => tabVal === 0 ? 1 : 0);
            }
        });
    }, [])



    return (
        <React.Fragment>
            <CssBaseline />

            <Helmet><title>{`nice cock - Poly Pizza`}</title></Helmet>
            {/* <PrimarySearchAppBar loggedIn={props.isLoggedIn} history={props.history} isLoading={props.isLoading} /> */}
            <EditAppBar history={props.history} onSave={handleSubmit(onSubmit)} title={"Edit Post"}></EditAppBar>

            <Paper className='max-w-3xl mx-auto  !bg-gray-dark'>

                {/* Tab switcher */}
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className='bg-gray-dark rounded-md md:rounded-r-none flex-grow !sticky top-20 z-50 mt-6 mx-[25%]'>
                    <Tabs value={tabValue} indicatorColor="primary" textColor="primary" onChange={(e, value) => setTabValue(value)} centered>
                        <Tab classes={{ root: 'min-w-1' }} label={'Edit'} />
                        <Tab classes={{ root: 'min-w-1' }} label={'Preview'} />
                    </Tabs>
                </Box>

                <div className='mt-10'>

                    {/* Tab content */}
                    {tabValue === 0 &&
                        <Editor post={props.post}
                            deleteList={deleteList}
                            register={register}
                            control={control}
                            errors={errors}
                        />
                    }
                    {tabValue === 1 && <PostRenderer post={{ ...props.post, 'Title': getValues("Title"), 'Content': getValues("Content") }} />}
                </div>

            </Paper>
        </React.Fragment>
    );
}

function Editor(props: {
    deleteList: any; post: { BannerImage: any; Title: string; PublicID: string; Visibility: any; };
    register: any; control: any; errors: any;
}) {

    const [bannerImage, setBannerimage] = useState(props.post.BannerImage ? [props.post.BannerImage] : []);
    const [images, setImages] = useState(props.post.Images ? [props.post.Images] : []);
    const [deleteListDialog, setdeleteListDialog] = useState(false);

    // change text field height on key up
    function autoGrow(e) {
        let oField = e.target;
        oField.style.height = oField.scrollHeight + "px";
    }

    return (
        <div className='px-16 flex flex-col gap-10 mt-10'>
            <div className="flex flex-col gap-3">
                <textarea
                    defaultValue={props.post.Title}
                    placeholder={"Banger new post title"}
                    name="Title"
                    ref={props.register({ required: true })}
                    className="bg-[#00000000] border-none outline-none text-white-light text-4xl font-extrabold text-white font-mono overflow-hidden resize-none h-auto"
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                        }
                    }}
                    onInput={autoGrow}
                />
            </div>
            <div>
                <TextField
                    multiline
                    className='w-full'
                    minRows={40}
                    InputProps={{
                        classes: {
                            input: '!font-mono !text-lg',
                        },
                    }}
                    defaultValue={props.post.Content}
                    // value={props.editorState}
                    // onChange={(e) => props.seteditorState(e.target.value)}
                    name="Content"
                    inputRef={props.register({ required: true })}
                    variant="outlined"
                />

            </div>

            <div>
                <Typography variant="h6">Images</Typography>
                <Typography variant="body1" color="textSecondary" className="!my-2">Upload your banner image here</Typography>
                <ImageUploader
                    imageURLs={bannerImage}
                    setImageURLs={setBannerimage}
                    max={2}
                    uploadEndpoint={`/api/posts/${props.post.PublicID}/bannerImage`}
                    uploadField={'images'}
                    removeImage={(url: string) => {
                        const split = url.split('/');
                        const image = `${split[split.length - 2]}/${split[split.length - 1]}`;
                        axios.delete(`/api/list/${props.post.PublicID}/images/${encodeURIComponent(image)}`)
                    }}
                />

                <Typography variant="body1" color="textSecondary" className="!my-5">and the rest of your images here!</Typography>
                <ImageUploader
                    imageURLs={images}
                    setImageURLs={setImages}
                    max={5}
                    uploadEndpoint={`/api/posts/${props.post.PublicID}/images`}
                    uploadField={'images'}
                    uploadFinishedCB={(urls: string[]) => {
                        navigator.clipboard.writeText(urls.map((url) => `![${url.split('/').pop()}](${url})`).join('\n'));
                    }}
                    removeImage={(url: string) => {
                        const split = url.split('/');
                        const image = `${split[split.length - 2]}/${split[split.length - 1]}`;
                        axios.delete(`/api/list/${props.post.PublicID}/images/${encodeURIComponent(image)}`)
                    }}
                />
            </div>

            <div className='w-full'>
                <Typography variant="h6">Visibility</Typography>
                <Typography variant="body1" color="textSecondary" className="!my-2">When you're ready to publish, set this to public!</Typography>
                <ReactHookFormSelect
                    name="Visibility"
                    label="Visibility"
                    control={props.control}
                    placeholder="Visibility"
                    fullWidth
                    error={props.errors.Visibility !== undefined}
                    defaultValue={props.post.Visibility || 0}>
                    <MenuItem value={'Unlisted'}>Unlisted</MenuItem>
                    <MenuItem value={'Public'}>Public</MenuItem>
                </ReactHookFormSelect>
            </div>

            <div className=" flex flex-col gap-4 mb-[10vh]">
                <Typography variant='h6' className=''>⚠️Danger zone</Typography>
                <Button variant="outlined" onClick={() => setdeleteListDialog(true)}>Delete Post</Button>
            </div>

            <SimpleConfirm
                setOpen={setdeleteListDialog}
                open={deleteListDialog}
                action={props.deleteList}
                title="Delete Post?"
                content="Do you want to delete this post? You can't undo this."
            />
        </div>
    )
}

BlogEdit.getInitialProps = async ({ req, res, match, history, location, ...ctx }) => {

     //@ts-ignore
     const isLoggedIn = req !== undefined ? ctx.authed : authed;  //if SSR, use authed from context, otherwise use local var;

     if(!isLoggedIn) {
         return {statusCode: 404}
     }

    //Get ID from url by splitting - and getting last one
    const id = match.params.id.split('-').pop();

    //Try get post from API
    let post: any;
    try {
        post = (await axios.get(`${process.env.SITE_ROOT}/api/posts/${id}`, { withCredentials: true })).data;
    } catch (e) {
        return { statusCode: 404 };
    }

    return { isLoggedIn, post }
}

export default BlogEdit;